import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {DisplaySymbolExplainedComponent} from './display-symbol-explained.component';
import {DisplaySymbolWithIconComponent} from './display-symbol-with-icon';
import {DisplaySymbolComponent} from './display-symbol.component';
import {ParseSecurityKeyPipe} from './parse-security-key.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        DisplaySymbolComponent,
        ParseSecurityKeyPipe,
        DisplaySymbolWithIconComponent,
        DisplaySymbolExplainedComponent
    ],
    exports: [
        DisplaySymbolComponent,
        ParseSecurityKeyPipe,
        DisplaySymbolWithIconComponent,
        DisplaySymbolExplainedComponent
    ]
})
export class DisplaySymbolModule {}
